import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18next';
import { shoppingCartApiSlice } from './ShoppingCartApi';

const SLICE_NAME = 'shoppingCartParts';

const shoppingCartPartsSlice = createSlice({
  name: SLICE_NAME,
  initialState: {},
  reducers: {},
  extraReducers(builder) {
    builder.addMatcher(
      shoppingCartApiSlice.endpoints.addPartToShoppingCart.matchFulfilled,
      (state, { payload: part }) => {
        // TODO: notification
        // notify.success(
        //  i18n.t('parts:notifications.added-to-cart', { name: part.partName, amount: part.numberOfParts }),
        //);
      },
    );
    builder.addMatcher(shoppingCartApiSlice.endpoints.deleteOrderLine.matchFulfilled, (state, { payload: part }) => {
      // TODO: notification
      // notify.success(i18n.t('shoppingCart:notifications.item.item-deleted-notification', { name: part.partName }));
    });
    builder.addMatcher(shoppingCartApiSlice.endpoints.updateOrderLine.matchFulfilled, (state, { payload: part }) => {
      // TODO: notification
      // notify.success(i18n.t('shoppingCart:notifications.item.item-updated-notification', { name: part.partName }));
    });
  },
});

export default shoppingCartPartsSlice.reducer;
